<template>
  <div>
    <div style="display: flex; flex-wrap: wrap;">
      <div
        class="item-child-t"
        v-for="(chunk, index) in chunkedItems"
        :key="index"
        style="width: 517px; margin-right: 10px;"
      >
        <div class="tek-item-t">
          <div
            v-for="(itemTek, indTek) in chunk"
            :key="indTek"
            :class="{ bg: indTek % 2 === 1 }"
          >
            <div 
              class="tek-for-type" 
              :class="{ border_top: indTek == 0 }">
              <div style="display: flex; cursor: pointer;">
                <div>
                  <div style="display: flex; width: 397px;">
                    <b-form-checkbox
                      v-if="!itemTek.type"
                      @change="ChakkedType(itemTek)"
                      v-model="itemTek.select"
                      :value="true"
                      :unchecked-value="false"
                    >
                      {{ itemTek.name }}
                    </b-form-checkbox>
                    <span v-if="itemTek.type">{{ itemTek.name }}</span>
                  </div>
                </div>
                <div v-if="!itemTek.type">
                  <span v-if="$store.state.bemor.citizen">{{
                    itemTek.citizen_price | numFormat
                  }}</span>
                  <span v-else>{{ itemTek.price | numFormat }}</span>
                </div>
              </div>
              <div class="item-child" v-if="itemTek.type">
                <TekChild
                  :itemChild="itemTek.inspectionChild"
                  :TekItem="itemTek"
                  @ChakkedChild="ChakkChild"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TekChild from "./TekChild.vue";
export default {
  props: ["itemBol", "indBolim"],
  components: {
    TekChild
  },
  data() {
    return {
      itemsPerChunk: 1,
      localUser: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    chunkedItems() {
      const chunks = [];
      for (let i = 0; i < this.itemBol.length; i += this.itemsPerChunk) {
        chunks.push(this.itemBol.slice(i, i + this.itemsPerChunk));
      }
      return chunks;
    }
  },
  methods: {
    ChakkedType(item) {
      for (let index = 0; index < item.inspectionChild.length; index++) {
        const element = item.inspectionChild[index];
        element['child_id'] = element.id
      }
      if (this.$store.state.bemor.id) {
        this.$emit("itemTek", item);
      } else {
        item.select = false;
        this.$emit("itemTek", item);
        return (item.select = false);
      }
    },
    ChakkChild(TekItem, child) {
      this.$emit("chekkTekChild", TekItem, child);
    }
  },
  
};
</script>
<style>
.table-style {
  background: #fff;
}
.item-child-t {
  margin: 5px;
  display: flex;
  /* padding: 5px; */
  /* background: #f0f0f03d; */
  /* border-radius: 5px; */
  /* border: 1px solid #ccc; */
}
.tek-for-type {
  /* border: 1px solid #ccc; */
  padding: 3px 5px;
  border-top: none;
  min-height: 30px;
}
.Tekshiruvchi-index {
  width: 530px;
}
.item-child {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  margin-top: 5px;
  max-height: 650px;
}
.border_top {
  /* border-top: 1px solid #ccc; */
}
.tek-item-t {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  background: #fff;
  /* padding: 5px; */
  border-radius: 7px;
  overflow: auto;
  /* margin-top: 5px; */
  max-height: 700px;
}
</style>
